import React, { useMemo, useState } from "react";
import { useToast } from "../../../Hooks/ToasContext";

import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Box, Button, Typography } from '@mui/material'
import { ISellerEntity } from "../../../Services/api/sellers/sellers.interface";
import { ListSellersUseCase } from "../../../Usecase/Sellers/list-sellers-usecase";


interface IuseListSellersProps {
    listSellersUseCase: ListSellersUseCase
}
export function useListSellers({ listSellersUseCase }: IuseListSellersProps){
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<ISellerEntity[]>([])
    const [sellerToDestroy, setSellerToDestroy] = useState<ISellerEntity | null>(null)
    const [sellerToResetPassword, setSellerToResetPassword] = useState<ISellerEntity | null>(null)

    const { showToast } =  useToast()

    const listSellers = async ({ page: currentPage, search}: { page : number; search?: string }) => {
        
        try {
          setLoading(true)
          
          const listResult = await listSellersUseCase.handle({ page: currentPage, searchBy: search });

          if (listResult.isFailure) {
       
            showToast(String(listResult?.error?.error), 'error');
            return;
          }

         const list = listResult.getValue()

         if(list){
            setData(list.data)
         }

         setPage(currentPage)
        } catch (error) {
          console.log("error useListSellers function: ", error)
        } finally {
          setLoading(false);
        }
      };

    

    const list = useMemo(() => {
        const rows = data?.map(product => {

            return {
                ...product
            }
        })

        return rows
    }, [data])

      

    return {
        loading,
        listSellers,
        list,
        data,
        sellerToDestroy,
        setSellerToDestroy,
        sellerToResetPassword,
        setSellerToResetPassword
        
    }
}